import React from 'react';
import Drawer from '../../ui-components/Drawer/Drawer';
import { Modal } from '.';
import Typography, {
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import BetaIcon, { IconSizes } from '../Icons/Icon';

const ModalDrawer = ({
  content,
  title,
  isOpen,
  setIsOpen,
  isDeviceSmallerThanTablet,
  modalCustomWidth,
  footer,
  handleBeforeClose,
  handleAfterClose,
  goBack,
  fullDrawer = false,
  hideHeader = false,
}) => {
  const closeAndClear = () => {
    if (handleBeforeClose) {
      handleBeforeClose();
    }
    setIsOpen(false);
    if (handleAfterClose) {
      handleAfterClose();
    }
  };

  return isDeviceSmallerThanTablet ? (
    <>
      {hideHeader && (
        <style>
          {`
            .drawer__header {
              border-bottom: none !important;
            }
            .drawer__body {
              padding: 1rem 1rem 3rem !important;
              overflow-y: hidden !important;
            }
            .drawer__footer {
              display: none !important;
            }
          `}
        </style>
      )}
      <Drawer
        goBack={goBack}
        classNames={!fullDrawer ? 'drawer--content-start' : ''}
        isOpen={isOpen}
        onClose={closeAndClear}
        title={
          <Typography
            variant={TypographyVariants.p2}
            weight={TypographyWeights['semi-bold']}
          >
            {title}
          </Typography>
        }
        body={content}
        footer={<div className="pt-m text-center">{footer}</div>}
      />
    </>
  ) : (
    <Modal
      isOpen={isOpen}
      onClickOverlay={closeAndClear}
      allowScroll={false}
      shouldScroll={false}
      modalCustomWidth={modalCustomWidth}
      noPadding={hideHeader}
    >
      <div className="d-flex flex-column"></div>
      <div>
        {!hideHeader && (
          <div className="modal-response__header">
            {goBack && (
              <div className="modal-response__header__back-btn">
                <button className="pointer" onClick={goBack}>
                  <BetaIcon name={'arrowLeft'} size={IconSizes[16]} />
                </button>
              </div>
            )}

            <div className="modal-response__header__close-btn">
              <button className="pointer" onClick={closeAndClear}>
                <BetaIcon name={'close'} size={IconSizes[16]} />
              </button>
            </div>

            <Typography
              variant={TypographyVariants.h6}
              weight={TypographyWeights['semi-bold']}
            >
              {title}
            </Typography>
          </div>
        )}
        {hideHeader && (
          <div className="modal-response__header__close-btn" style={{ position: 'absolute', right: '1rem', top: '1rem', zIndex: 10 }}>
            <button className="pointer" onClick={closeAndClear}>
              <BetaIcon name={'close'} size={IconSizes[16]} />
            </button>
          </div>
        )}
        <div className="d-flex flex-column">
          {content}
          {footer}
        </div>
      </div>
    </Modal>
  );
};

export default ModalDrawer;
